import { GenerateButton, SubmitButton } from '@/components/ui/Button';
import { WandSparkles } from 'lucide-react';

interface CompanySectionHeaderProps {
  title: string;
  onGenerate?: () => void;
  onAddTarget?: () => void;
  generateLabel?: string;
}

export default function CompanySectionHeader({
  title,
  onGenerate,
  onAddTarget,
  generateLabel,
}: Readonly<CompanySectionHeaderProps>) {
  return (
    <div className="flex items-center justify-between px-5 mt-5">
      <h1 className="text-lg font-semibold">{title}</h1>
      <div className="flex gap-2">
        {onGenerate && (
          <GenerateButton onClick={onGenerate}>
            <WandSparkles size={16} />
            {generateLabel || 'Generate'}
          </GenerateButton>
        )}
        {onAddTarget && (
          <SubmitButton onClick={onAddTarget}>
            + Add Target
          </SubmitButton>
        )}
      </div>
    </div>
  );
}
